import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  acceptSubprojectInvitation,
  AcceptSubprojectInvitationInput,
} from '@/features/partners/api/accept-subproject-invitation';

type Props = Omit<
  UseMutationOptions<
    Awaited<ReturnType<typeof acceptSubprojectInvitation>>,
    unknown,
    AcceptSubprojectInvitationInput
  >,
  'mutationFn'
>;

export const useAcceptSubprojectInvitationMutation = ({ ...props }: Props) => {
  return useMutation({
    ...props,
    mutationFn: async (data) => {
      return await acceptSubprojectInvitation(data);
    },
  });
};
